export const isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const isMobile = /^(05)([0-9]{8})$/i;
export const beginWith966 = /^966/;
export const Alphanumeric = /^[a-zA-Z0-9_ \u0600-\u06FF]*$/;
